module.exports = __webpack_public_path__ + "static/media/05._Count_Three.cb4905c2.PNG";